"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/blog/general-blog-01.jpg" | "/Templates/Doccure/img/blog/general-blog-02.jpg" | "/Templates/Doccure/img/blog/general-blog-03.jpg" */
    src: string;
    /** Detected variants: "Health Awareness" | "Healthcare Technology" | "General Dentistry" */
    link1Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/patients/patient12.jpg" | "/Templates/Doccure/img/patients/patient20.jpg" | "/Templates/Doccure/img/patients/patient21.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Grace Morgan" | "Daniel Scott" | "Jacob Allen" */
    link1Link1Text: ReactNode;
    /** Detected variants: "10, Sep 2026" | "15, Sep 2026" | "25, Sep 2026" */
    p0Text: ReactNode;
    /** Detected variants: "The Importance of Early Diagnosis: Why Timing Matters..." | "How Technology Is Transforming Modern Hospitals" | "When to Visit the Emergency Room: 5 Critical Warning Signs" */
    link0Text: ReactNode;
    /** Detected variants: "Early diagnosis can dramatically improve treatment success. Detecting conditions in their earliest..." | "Hospitals today use advanced diagnostics, AI tools, robotic surgeries, and digital health records..." | "Knowing emergency symptoms can save lives. Severe chest pain, sudden weakness, intense..." */
    p0P0Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "blog-item-two w-100 wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "blog-img" */
    div0ClassName2?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "blog" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "badge" */
    link1ClassName?: string;
    /** Detected variants: "all_routes.blogGrid" */
    link1Href?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "blog-user-info" */
    div0ClassName3?: string;
    /** Detected variants: "blog-user" */
    div0ClassName4?: string;
    /** Detected variants: "avatar avatar-md" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "user" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid rounded-circle" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "#" */
    link1Href2?: string;
    /** Detected variants: "date" */
    p0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href2?: string;
    /** Detected variants: "mb-0" */
    p0ClassName2?: string;
};
export type HomeTwoBlogSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection46sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Blogs & Articles" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Latest News & Stories" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div2DivDataWowDuration?: string;
    /** Default: "all_routes.blogList" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Blogs" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    blogSection46s: BlogSection46sItem[];
    blogSection46sItemWrapper?: (item: BlogSection46sItem, content: ReactNode) => ReactNode;
    blogSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection46sLinkVisible?: boolean;
    blogSection46sLinkRenderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sImageVisible?: boolean;
    blogSection46sImageRenderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sH3Visible?: boolean;
    blogSection46sH3Renderer?: (item: BlogSection46sItem, defaultNode: ReactNode) => ReactNode;
    blogSection46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwoBlogSectionGenerated: FC<HomeTwoBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Blogs & Articles",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Latest News & Stories",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div2DivDataWowDuration = "1s",
    sectionDiv0Div2Link0LinkHref = "all_routes.blogList",
    sectionDiv0Div2Link0LinkText = "View All Blogs",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div0Link1LinkProps,
    divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0Div0Link0LinkProps,
    divDiv0Div1Div0Div0Link1LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogSection46s,
    blogSection46sItemWrapper,
    blogSection46sRenderer,
    blogSection46sLinkVisible,
    blogSection46sLinkRenderer,
    blogSection46sImageVisible,
    blogSection46sImageRenderer,
    blogSection46sH3Visible,
    blogSection46sH3Renderer,
    blogSection46sLinkProps,
    blogSection46sImageProps,
    blogSection46sH3Props,
}) => {
    return (
        <section className="section blog-section">
            <div className="container">
                <div className="section-header section-header-two">
                    <div className="section-sub-title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title mb-0" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-4"}>
                    {renderCollectionNode(
                        blogSection46s,
                        (item: BlogSection46sItem) => (
                            <div className={item.className ?? "col-lg-4 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-two w-100 wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "blog-img"}>
                                        {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(blogSection46sImageVisible, blogSection46sImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "blog"} {...(typeof blogSection46sImageProps === "function" ? blogSection46sImageProps(item) : (blogSection46sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                            <SmartLink href={item.link1Href ?? "all_routes.blogGrid"} className={item.link1ClassName ?? "badge"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div0Link1LinkProps === "function" ? divDiv0Div0Link1LinkProps(item) : (divDiv0Div0Link1LinkProps ?? {}))}>{item.link1Text}</SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        <div className={item.div0ClassName3 ?? "blog-user-info"}>
                                            <div className={item.div0ClassName4 ?? "blog-user"}>
                                                {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "#"} className={item.link0ClassName ?? "avatar avatar-md"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Link0LinkProps === "function" ? divDiv0Div1Div0Div0Link0LinkProps(item) : (divDiv0Div1Div0Div0Link0LinkProps ?? {}))}>
                                                        {renderItemNode(blogSection46sImageVisible, blogSection46sImageRenderer, item, (
                                                            <SmartImage src={item.imageWithBasePath0Src} className={item.imageWithBasePath0ClassName2 ?? "img-fluid rounded-circle"} alt={item.imageWithBasePath0Alt ?? "user"} {...(typeof blogSection46sImageProps === "function" ? blogSection46sImageProps(item) : (blogSection46sImageProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </SmartLink>
                                                ))}
                                                {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                                    <SmartLink href={item.link1Href2 ?? "#"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Div0Link1LinkProps === "function" ? divDiv0Div1Div0Div0Link1LinkProps(item) : (divDiv0Div1Div0Div0Link1LinkProps ?? {}))}>{item.link1Link1Text}</SmartLink>
                                                ))}
                                            </div>
                                            <p className={item.p0ClassName ?? "date"}>{item.p0Text}</p>
                                        </div>
                                        {renderItemNode(blogSection46sH3Visible, blogSection46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection46sH3Props === "function" ? blogSection46sH3Props(item) : (blogSection46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(blogSection46sLinkVisible, blogSection46sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href2 ?? "all_routes.blogDetails"} {...(typeof blogSection46sLinkProps === "function" ? blogSection46sLinkProps(item) : (blogSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName2 ?? "mb-0"}>{item.p0P0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection46sItemWrapper,
                        blogSection46sRenderer
                    )}
                </div>
                <div className="view-all text-center wow fadeInUp" data-wow-duration={sectionDiv0Div2DivDataWowDuration}>
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-md btn-dark" {...(sectionDiv0Div2Link0LinkProps ?? {})}>{sectionDiv0Div2Link0LinkText}</SmartLink>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeTwoBlogSectionGenerated;
